
import { Component, Prop } from 'vue-property-decorator';
import { InputType } from '@/enums/InputType';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import { mixins } from 'vue-class-component';
import StackedForm from '@/mixins/StackedForm';
import { Category } from '@/interfaces/models/Category';
import { namespace } from 'vuex-class';
import Notification from '@/mixins/Notification';
import VenueApiService from '@/api/http/VenueApiService';
import _ from 'lodash';
import axios from 'axios';

const api = new VenueApiService();
const app = namespace('app');
let checkoutIntegrationProperties: any[] = [];

@Component({
  components: { VFormBuilder },
  created: () => {
    axios.get('/v1/foodcard/checkoutIntegrationProperties').then(({ data }) => (checkoutIntegrationProperties = data));
  },
})
export default class GeneralImportDialog extends mixins(StackedForm, Notification) {
  get items() {
    return [
      {
        name: 'checkoutIntegrationProperties',
        type: InputType.Select,
        label: 'article.generalImport.checkoutIntegration',
        rules: 'required',
        items: this.checkoutIntegrationProperties,
      },
    ];
  }
  @Prop({ type: String, required: true }) public venueId!: string;

  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & {
      setData: (form: any) => void;
    };
  };
  public show: boolean = false;

  public setShowModal(showModal: boolean = true) {
    this.show = showModal;
    if (!showModal) {
      this.$refs.form.reset();
      this.$refs.form.clearErrors();
    }
  }

  public async save() {
    if (await this.$refs.form.validate()) {
      this.$startLoading('import_foodcard');
      const data = _.cloneDeep(this.$refs.form.getData());
      await api.generalImport(this.venueId, data.checkoutIntegrationProperties);
      this.$stopLoading('import_foodcard');
      this.setShowModal(false);
      this.$emit('updateFoodcard');
      this.notifySuccess('article.deliverect.success');
    }
  }

  private checkoutIntegrationProperties() {
    return checkoutIntegrationProperties.map((property) => ({
      text: `${property.name}\t[${property.checkoutType}]`,
      value: property,
    }));
  }
}
